import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from 'antd';
import { EmptyState } from '@shared/ui';
import { ConversationsList } from '@features/chat-list';
import { ChatWindow } from '@features/chat-window';

export function ChatsPage() {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { id } = useParams<{ id?: string }>();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '320px 1fr',
        height: 'calc(100vh - 64px)',
        overflow: 'hidden',
        borderRadius: token.borderRadiusLG,
        background: token.colorBgContainer,
        border: `1px solid ${token.colorSplit}`,
      }}
    >
      <aside
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          borderRight: `1px solid ${token.colorSplit}`,
          background: token.colorFillQuaternary,
        }}
      >
        <header
          style={{
            padding: '12px 16px',
            borderBottom: `1px solid ${token.colorSplit}`,
          }}
        >
          <h1 style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>{t('chats.title')}</h1>
        </header>
        <ConversationsList />
      </aside>
      <section style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {id ? (
          <ChatWindow conversationId={id} />
        ) : (
          <EmptyState
            className="m-6"
            title={t('chats.selectConversation')}
            description={t('chats.subtitle')}
          />
        )}
      </section>
    </div>
  );
}
